import ceLogo from "./media/ce.png";
import backgroundImage from "./media/background.jpg";
import footerLogo from "./media/powered-by-healo.png";
import constants from "../../../../common/constants";
import SV_TRANSLATION from "./messages/sv";
import EN_TRANSLATION from "./messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "football",
  image: {
    text: "logo.text"
  },
  imagePost: {
    text: "logo.text"
  },
  imageQA: null,
  ceLogo: ceLogo,
  backGroundVideo: null,
  appBackground: {
    url: backgroundImage,
    overlayStyle: {
      mixBlendMode: "multiply",
      backgroundImage: "linear-gradient(241deg, #49accd, #9bcd8c)"
    }
  },
  secondaryBackground: {
    backgroundColor: "rgb(255, 255, 255, 0.9)",
    gradientColors: ["rgb(255, 255, 255, 0.9)", "rgb(255, 255, 255, 0.8)"]
  },
  footerImage: footerLogo,
  baseClass: "brand-football",
  domains: [
    "http://localhost:4007",
    "https://dev-football.healo.app",
    "https://dev-fotboll.healo.app",
    "https://stg-football.healo.app",
    "https://stg-fotboll.healo.app",
    "https://football.healo.app",
    "https://fotboll.healo.app"
  ],
  clinicCityEnabled: false,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1116 : 1104,
  ssnEnabled: true,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  },
  defaultLanguage: [
    {
      test: [".*football.*"],
      language: constants.appLanguages.en
    }
  ]
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/football/settings.js